<!-- 测评模板筛选 -->
<template>
  <side-base>
    <div class="swrap">
      <div class="shead">
        <div @click="selectCepingCategory">{{cepingCategoryText}}<van-icon
          class="xiala"
          class-prefix="vxs-icon"
          name="system_choose"
          size="10"
          color="var(--g6)"
        /></div>
      </div>

      <div class="smain">
        <div class="slist">
          <div
            class="sitem van-hairline--bottom"
            v-for="item in listAll"
            :key="item.id"
            @click="clickHandler(item)"
          >
            <div class="l sicon">
              <side-icon-select :checked="ids.includes(item.id)" />
            </div>
            <div class="r">
              <div class="rln1">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="desc" v-if="listAll.length">没找到合适的测评项目？<span class="link" @click="$router.push('/cepingItemAdd')">新增测评项目</span></div>
        <van-empty
          v-if="listAll.length === 0 && !loading"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
          description="暂无测评项目"
          image-size="128"
          style="margin-top: 20vh"
        ><span class="link" @click="$router.push('/cepingItemAdd')">新增测评项目</span></van-empty>
      </div>

      <side-foot
        @cancel="close"
        @confirm="confirm(getRet())"
        :confirmSubText="config.radio ? '' : `(${list.length})`"
      >
        <select-Base
          :show="!config.radio"
          :ids="ids"
          :list="list"
          key_txt="name"
          :isAll="checkAll"
          @clickAllBtn="checkAll = !checkAll"
        />
      </side-foot>
    </div>
  </side-base>
</template>

<script>
import sideMixin from '@x3/js/side/0_mixin/mixin-select.js';

export default {
  name: 'x3-side-ceping-item-filtrate',
  mixins: [sideMixin],
  data() {
    return {
      pageTitle: '选择测评项目',
      // 是否正在加载数据
      loading: true,
      listAll: [],
      api: this.$api.evaluationItemList,
      params: {
        itemTypeIds: [],
        statusList: [1],
        page: {
          pageNum: 1, 
          pageSize: 999
        }
      },
      itemTypeLists: [],
      config: {
        radio: false
      },
    };
  },
  computed: {
    cepingCategoryText: function () {
      let its = this.params.itemTypeIds,
        text = '';
      if (its.length == 0) {
        text = '全部测评项目类型';
      } else if (its.length == 1) {
        text = this.itemTypeLists[0].name;
      } else {
        text = `${its.length}个测评项目类型`;
      }
      return text;
    },
  },
  methods: {
    async render() {
      let ret = await this.api(this.params);
      this.listAll = ret.data;
      this.loading = false;
    },
    async selectCepingCategory() {
      let res = await app.x3.side.xsCepingCategoryFiltrate({
        ids: this.params.itemTypeIds,
        list: this.itemTypeLists,
      });
      this.params.itemTypeIds = res.ids;
      this.itemTypeLists = res.list;
    }
  },
  async created() {
    this.render();

    this.$onBus("refresh-ceping-item-setting", () => {
      this.$set(this.params, "_refreshFlag_", Date.now())
    });
  },
  watch: {
    'params.itemTypeIds': {
      handler: function (nv, ov) {
        this.render();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.swrap {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .shead {
    padding: calc(var(--gap) * 16);
  }
  .smain {
    flex: 1;
    overflow: auto;
    .slist {
      padding: 0 calc(var(--gap) * 16);
      background: var(--white);
      .sitem {
        display: flex;
        padding: calc(var(--gap) * 12) 0;
        .l.sicon {
          margin-right: calc(var(--gap) * 16);
          padding-top: calc(var(--gap) * 2);
        }
        .r {
          flex: 1;
          .rln1 {
            color: var(--g8);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
          }
        }
      }
    }
    .desc {
      text-align: center;
      padding: calc(var(--gap) * 16) 0;
      color: var(--g6);
      font-size:var(--fs-sm);
      line-height:var(--lh-sm);
    }
    .link {
       color: var(--tlc);
    }
  }
}
</style>